import { ISelectOption } from '@apps-common/types/form'

export const UNIT_STATUS_ACTIVE: ISelectOption = {
  label: 'Status Active',
  value: 'active'
}

export const UNIT_STATUS_INACTIVE: ISelectOption = {
  label: 'Status Inactive',
  value: 'inactive'
}

export const UNIT_STATUS_PENDING_CANCELLATION: ISelectOption = {
  label: 'Status Pending Cancellation',
  value: 'pending_cancellation'
}

export const UNIT_STATUS_CANCELLED: ISelectOption = {
  label: 'Status Cancelled',
  value: 'cancelled'
}

export const UNIT_STATUS_UNKNOWN: ISelectOption = {
  label: 'Status Unknown',
  value: 'unknown'
}

export const UNIT_STATUS_VALUES: ISelectOption[] = [
  UNIT_STATUS_ACTIVE,
  UNIT_STATUS_INACTIVE,
  UNIT_STATUS_PENDING_CANCELLATION,
  UNIT_STATUS_CANCELLED
]

export const UNIT_ORDER_DEFAULT: ISelectOption = {
  label: 'Sort by added on',
  value: 'DateLoaded'
}

export const UNIT_ORDER_DATE_DELETED: ISelectOption = {
  label: 'Sort by cancelled on',
  value: 'DateDeleted',
  valueCheck: UNIT_STATUS_CANCELLED.value as string
}

export const UNIT_ORDER_VALUES: ISelectOption[] = [
  UNIT_ORDER_DEFAULT,
  UNIT_ORDER_DATE_DELETED,
  {
    label: 'Sort by account no',
    value: 'AccountNo'
  },
  {
    label: 'Sort by mobile no',
    value: 'MobileNo'
  },
  {
    label: 'Sort by site name',
    value: 'Site'
  }
]

// unit filter defaults
